import { memo, useCallback } from 'react';
import { Card, SaveToContactsIcon } from '@halo/ui-chat-react';
import {
  Box,
  type CheckboxCheckedChangeDetails,
  Flex,
  Spinner,
  Stack,
  Switch,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const SaveToContactsCard = memo(function SaveToContactsCard({
  open,
  onOpen,
  onClose,
  loading = false,
}: {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  loading?: boolean;
}) {
  const { t } = useTranslation();
  const handleCheckedChange = useCallback(
    async (details: CheckboxCheckedChangeDetails) => {
      if (loading) return;
      const { checked } = details;
      if (checked) {
        onOpen();
      } else {
        onClose();
      }
    },
    [onOpen, onClose, loading]
  );

  return (
    <Card>
      <Flex alignItems="center" gap="2.5" justifyContent="space-between">
        <Flex gap="2.5" alignItems="center">
          <Box fontSize="4xl">
            <SaveToContactsIcon />
          </Box>
          <Stack gap="1">
            <Text fontSize="sm" fontWeight="medium">
              {t('chatSettings.saveToContacts')}
            </Text>
          </Stack>
        </Flex>
        <Box fontSize="lg" cursor="pointer">
          <Switch.Root
            css={{ marginRight: '0' }}
            checked={open}
            onCheckedChange={handleCheckedChange}
          >
            <Switch.HiddenInput />
            <Switch.Control>
              <Switch.Thumb>{loading && <Spinner size="xs" />}</Switch.Thumb>
            </Switch.Control>
          </Switch.Root>
        </Box>
      </Flex>
    </Card>
  );
});
